import { ResponseDataGet } from "../../../../models/responseDataGet";
import { agroApi } from "../../api";
import { Paths } from "../../../../paths";
import { EntInitialFilter } from "../../../../models/filters/initialFilter";
import { EntBasicHB } from "../../../../models/handBooks/basicHB";

export const seasonalityApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getSeasonalityList: builder.query<ResponseDataGet<EntBasicHB>, EntInitialFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.seasonality }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getSeasonalityById: builder.query<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.seasonality }/${ id }`,
		method: 'GET',
	  }),
	}),

	addSeasonality: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.seasonality }`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	}),

	editSeasonality: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.seasonality }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteSeasonality: builder.mutation<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.seasonality }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddSeasonalityMutation,
  useDeleteSeasonalityMutation,
  useEditSeasonalityMutation,
  useGetSeasonalityByIdQuery,
  useGetSeasonalityListQuery,
  useLazyGetSeasonalityByIdQuery,
  useLazyGetSeasonalityListQuery
} = seasonalityApi;
